import { Close as CloseIcon } from '@mui/icons-material'

const clampProgress = (value) => {
	return Math.max(0, Math.min(100, value))
}

const FloatingSidebarCard = ({ card, visible, defaultIcon = null, onAction, onDismiss }) => {
	if (!visible || !card) {
		return null
	}

	const cardClassName = ['scout-panel', 'scout-panel--accent', 'scout-floating-sidebar-card__panel', card?.className]
		.filter(Boolean)
		.join(' ')
	const progress = typeof card?.progress === 'number' ? clampProgress(card.progress) : null

	return (
		<div className="scout-floating-sidebar-card" aria-live="polite">
			<section className={cardClassName}>
				<div className="scout-panel__accent-topbar">
					<div className="scout-panel__status-icon">
						{card.icon || defaultIcon}
					</div>
					{card?.dismissible !== false && onDismiss ? (
						<button type="button" className="scout-panel__dismiss-button" onClick={onDismiss} aria-label="Fechar aviso">
							<CloseIcon />
						</button>
					) : null}
				</div>

				<div>
					<h3>{card.title}</h3>
					<p>{card.description}</p>
				</div>

				{progress !== null ? (
					<div className="scout-side-progress">
						<div className="scout-side-progress__bar">
							<div style={{ width: `${progress}%` }} />
						</div>
					</div>
				) : null}

				<button type="button" className="scout-primary-button scout-primary-button--light scout-floating-sidebar-card__action" onClick={() => onAction?.(card.action)}>
					{card.actionLabel || 'Abrir'}
				</button>
			</section>
		</div>
	)
}

export default FloatingSidebarCard